<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";

/**
 * Starter page component
 */
export default {
  page() {
    return {
      title: this.$t("device.hd.text"),
      meta: [{ name: "description" }],
    };
  },
  components: { Layout, PageHeader },
  data() {
    return {
      title: "",
      items: [],
      stockinfo: [],
      devicesearch: "",
      getdeviceslist: "",
      selectdevicestatus: "-1",
      loading: true,
      ismobile: false,
      activeNames: [],
      activeapp: [],
      showmodel: "1",
      userinfo: [],
      deviceid: 0,
      hdinfo: [],
      subid: 0,
      goodslist: [],
      goodsallcount: 0,
      goodsallpage: 0,
      goodspage: 1,
      id: 0,
      systemtype: 0,
      cashierconfig: [],
      sharedGid: 0,
    };
  },
  mounted() {
    this.title = this.$t("device.hd.text");
    this.items = [
      {
        text: this.$t("menuitems.devices.text"),
        href: "/",
      },
      {
        text: this.$t("menuitems.devices.lists"),
        href: "/device/list",
      },
      {
        text: this.$t("menuitems.devices.devicedetail"),
        href: "/device/devicedetail?id=" + this.$route.query.id,
      },
      {
        text: this.$t("device.hd.text"),
        active: true,
      },
    ];
    this.userinfo = JSON.parse(localStorage.getItem("user"));
    this.getgoodslist();
    this.gethdinfo();
    let flag = navigator.userAgent.match(
      /(phone|pod|iPhone|iPod|ios|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
    );
    if (flag) {
      this.ismobile = true;
    }
    this.deviceid = this.$route.query.id;
    this.getsysteminfo();
    this.getcashierconfig();
  },
  methods: {
    getsysteminfo() {
      var that = this;
      that.$axios
        .post(
          that.apiuri,
          {
            action: "systeminfo",
          },
          {
            headers: { Openid: that.userinfo.openid },
          }
        )
        .then(function (response) {
          that.systemtype = parseInt(response.data.data.model);
        })
        .catch(function (error) {
          // console.log(error);
        });
    },
    gethdinfo() {
      var that = this;
      that.$axios
        .post(
          that.apiuri,
          {
            action: "gethdinfo",
            id: that.$route.query.id,
          },
          {
            headers: { Openid: that.userinfo.openid },
          }
        )
        .then(function (response) {
          that.loading = false
          that.hdinfo = response.data.data.hd;
          that.subid = response.data.data.subcode;
          that.initSharedGid();
        })
        .catch(function (error) {
          // console.log(error);
        });
    },
    initSharedGid() {
      if (Number(this.subid) !== 7500 || !this.hdinfo || !this.hdinfo.length) {
        this.sharedGid = 0;
        return;
      }
      const withGid = this.hdinfo.find(function (item) {
        return item.gid && Number(item.gid) !== 0;
      });
      this.sharedGid = withGid ? withGid.gid : (this.hdinfo[0].gid || 0);
    },
    saveSharedGid(gid) {
      var that = this;
      if (!that.hdinfo || !that.hdinfo.length) {
        return;
      }
      that.sharedGid = gid;
      that.loading = true;
      var requests = that.hdinfo.map(function (item, idx) {
        that.$set(that.hdinfo[idx], "gid", gid);
        return that.$axios
          .post(
            that.apiuri,
            {
              action: "changehdinfo",
              hid: item.id,
              key: "gid",
              value: gid,
            },
            {
              headers: { Openid: that.userinfo.openid },
            }
          )
          .then(function (response) {
            if (response.data.status == 200) {
              that.savecommand("goods", item.id);
              return true;
            }
            return false;
          })
          .catch(function () {
            return false;
          });
      });
      Promise.all(requests)
        .then(function (results) {
          that.loading = false;
          if (results.every(Boolean)) {
            that.$message({
              message: that.$t("global.change.success"),
              type: "success",
            });
          } else {
            that.$message.error(that.$t("global.change.fail"));
          }
        })
        .catch(function () {
          that.loading = false;
          that.$message.error(that.$t("global.change.fail"));
        });
    },
    getgoodslist() {
      var that = this;
      that.$axios
        .post(
          that.apiuri,
          {
            action: "goodslist",
            id: that.$route.query.id,
          },
          {
            headers: { Openid: that.userinfo.openid },
          }
        )
        .then(function (response) {
          that.goodslist = response.data.data;
        })
        .catch(function (error) {
          // console.log(error);
        });
    },
    addhd() {
      var that = this;
      that.$axios
        .post(
          that.apiuri,
          {
            action: "addhd",
            id: that.$route.query.id,
          },
          {
            headers: { Openid: that.userinfo.openid },
          }
        )
        .then(function (response) { })
        .catch(function (error) {
          // console.log(error);
        });
    },
    save(key, hid, e) {
      var that = this;
      that.$axios
        .post(
          that.apiuri,
          {
            action: "changehdinfo",
            hid: hid,
            key: key,
            value: e.target.value,
          },
          {
            headers: { Openid: that.userinfo.openid },
          }
        )
        .then(function (response) {
          if (response.data.status == 200) {
            that.$message({
              message: that.$t("global.change.success"),
              type: "success",
            });
            // 7720：changehdinfo 已自动 portugal4lanesetgoods，无需再走 savegoodsinfo
            if (Number(that.subid) !== 7720) {
              that.savecommand("goods", hid);
            }
          } else {
            that.$message.error(that.$t("global.change.fail"));
          }
        })
        .catch(function (error) {
          // console.log(error);
        });
    },
    savev2: function (key, hid, idx) {
      var that = this;
      that.$axios
        .post(
          that.apiuri,
          {
            action: "changehdinfo",
            hid: hid,
            key: key,
            value: that.hdinfo[idx].gid,
          },
          {
            headers: { Openid: that.userinfo.openid },
          }
        )
        .then(function (response) {
          if (response.data.status == 200) {
            that.$message({
              message: that.$t("global.change.success"),
              type: "success",
            });
            if (Number(that.subid) !== 7720) {
              that.savecommand("goods", hid);
            }
          } else {
            that.$message.error(that.$t("global.change.fail"));
          }
        })
        .catch(function (error) {
          // console.log(error);
        });
    },
    savelocal(key, hid, e) {
      var that = this;
      that.$axios
        .post(
          that.apiuri,
          {
            action: "changehdinfo",
            hid: hid,
            key: key,
            value: e,
          },
          {
            headers: { Openid: that.userinfo.openid },
          }
        )
        .then(function (response) {
          if (response.data.status == 200) {
            that.$message({
              message: that.$t("global.change.success"),
              type: "success",
            });
            if (Number(that.subid) !== 7720) {
              that.savecommand("goods", hid);
            }
          } else {
            that.$message.error(that.$t("global.change.fail"));
          }
        })
        .catch(function (error) {
          // console.log(error);
        });
    },
    deletes: function (type, id) {
      var that = this;
      if (type == "hd") {
        that
          .$confirm(
            that.$t("global.delete.deletehdtip"),
            that.$t("global.delete.sureyouaction"),
            {
              confirmButtonText: that.$t("global.button.ok"),
              cancelButtonText: that.$t("global.button.cancel"),
              type: "warning",
            }
          )
          .then(() => {
            that.$axios
              .post(
                that.apiuri,
                {
                  action: "delete",
                  type: type,
                  id: id,
                },
                {
                  headers: { Openid: that.userinfo.openid },
                }
              )
              .then(function (response) {
                if (response.data.status == 200) {
                  that.$message({
                    message: that.$t("global.delete.success"),
                    type: "success",
                  });
                } else if (response.data.status == 403) {
                  that.$message({
                    message: that.$t("global.delete.auth"),
                    type: "warning",
                  });
                } else {
                  that.$message.error(that.$t("global.delete.500"));
                }
                that.gethdinfo();
              })
              .catch(function (error) {
                // console.log(error);
              });
          })
          .catch(() => { });
      }
    },
    openboolcommand: function (type, id) {
      var that = this;
      if (type == "hd") {
        that.$axios
          .post(
            that.apiuri,
            {
              action: "beerdoor",
              id: id,
            },
            {
              headers: { Openid: that.userinfo.openid },
            }
          )
          .then(function (response) {
            if (response.data.status == 200) {
              that.$message({
                message: that.$t("global.success"),
                type: "success",
              });
            } else {
              that.$message.error(that.$t("global.failed"));
            }
          })
          .catch(function (error) {
            // console.log(error);
          });
      }
    },
    openwithcommand: function (type, id) {
      var that = this;
      if (type == "hd") {
        that.$axios
          .post(
            that.apiuri,
            {
              action: "gethdinfo_single",
              id: id,
            },
            {
              headers: { Openid: that.userinfo.openid },
            }
          )
          .then(function (response) {
            if (response.data.status == 200) {
              that.$axios
                .post(that.apiuri, {
                  action: "com.device.beer.open",
                  sn: response.data.key,
                  hdno: response.data.data.no,
                  payway: 0,
                  total: response.data.data.stock,
                  price: response.data.data.price,
                },
                  {
                    headers: { Openid: that.userinfo.openid },
                  })
                .then(function (response) {
                  if (response.data.status == 200) {
                    that.$message({
                      message: that.$t("global.success"),
                      type: "success",
                    });
                  } else {
                    that.$message.error(that.$t("global.failed"));
                  }
                })
                .catch(function (error) {
                  // console.log(error);
                });
            } else {
              that.$message.error(that.$t("global.failed"));
            }
          })
          .catch(function (error) {
            // console.log(error);
          });
      }
    },
    closewithcommand: function (type, id) {
      var that = this;
      if (type == "hd") {
        that.$axios
          .post(
            that.apiuri,
            {
              action: "gethdinfo_single",
              id: id,
            },
            {
              headers: { Openid: that.userinfo.openid },
            }
          )
          .then(function (response) {
            if (response.data.status == 200) {
              that.$axios
                .post(that.apiuri, {
                    action: "com.device.beer.close",
                    sn: response.data.key,
                  },
                  {
                    headers: { Openid: that.userinfo.openid },
                  })
                .then(function (response) {
                  if (response.data.status == 200) {
                    that.$message({
                      message: that.$t("global.success"),
                      type: "success",
                    });
                  } else {
                    that.$message.error(that.$t("global.failed"));
                  }
                })
                .catch(function (error) {
                  // console.log(error);
                });
            } else {
              that.$message.error(that.$t("global.failed"));
            }
          })
          .catch(function (error) {
            // console.log(error);
          });
      }
    },
    savecommand: function (type, id) {
      var that = this;
      if (type == "hd") {
        that.$axios
          .post(
            that.apiuri,
            {
              action: "savedeviceinfosetting",
              device: that.deviceid,
              id: id,
            },
            {
              headers: { Openid: that.userinfo.openid },
            }
          )
          .then(function (response) {
            if (response.data.status == 200) {
              that.$message({
                message: that.$t("global.success"),
                type: "success",
              });
            } else {
              that.$message.error(that.$t("global.failed"));
            }
          })
          .catch(function (error) {
            // console.log(error);
          });
      } else if (type == "goods") {
        var payload =
          Number(that.subid) === 7720
            ? { action: "portugal4lanesetgoods", id: that.deviceid }
            : { action: "savegoodsinfo", id: id };
        that.$axios
          .post(that.apiuri, payload, {
            headers: { Openid: that.userinfo.openid },
          })
          .then(function (response) {
            if (response.data.status == 200) {
              that.$message({
                message: response.data.msg || that.$t("global.syncsuccess"),
                type: "success",
              });
            } else if (response.data.status == 404) {
              that.$message.error(that.$t("device.lists.offline"));
            } else {
              that.$message.error(response.data.msg || that.$t("global.failed"));
            }
          })
          .catch(function (error) {
            // console.log(error);
          });
      }
    },
    initializehd() {
      var that = this;
      that.$axios
        .post(
          that.apiuri,
          {
            action: "initializehd",
            id: that.deviceid,
          },
          {
            headers: { Openid: that.userinfo.openid },
          }
        )
        .then(function (response) {
          that.loading = false;
          if (response.data.status == 200) {
            that.$message({
              message: that.$t("global.success"),
              type: "success",
            });
          }
          that.gethdinfo()
        })
        .catch(function (error) {
          // console.log(error);
        });
    },
    changehdstatus(status, id) {
      var that = this;
      let status2 = 0;
      if (status === 0) status2 = 1
      that.$axios
        .post(
          that.apiuri,
          {
            action: "changehdinfo",
            hid: id,
            key: "status",
            value: status2,
          },
          {
            headers: { Openid: that.userinfo.openid },
          }
        )
        .then(function (response) {
          if (response.data.status == 200) {
            that.$message({
              message: that.$t("global.change.success"),
              type: "success",
            });
            if (Number(that.subid) !== 7720) {
              that.savecommand("goods", id);
            }
          } else {
            that.$message.error(that.$t("global.change.fail"));
          }
        })
        .catch(function (error) {
          // console.log(error);
        });
    },
    getcashierconfig() {
      var that = this;
      that.loading = true;
      that.$axios
        .post(
          that.apiuri,
          {
            action: "get_cashier_config",
          },
          {
            headers: { Openid: that.userinfo.openid },
          }
        )
        .then(function (response) {
          that.loading = false;
          if (response.data.status == 200) {
            that.cashierconfig = response.data.config
            that.cashierstatus = that.cashierconfig.status
            if (that.cashierconfig.type == "hualala") {
              that.cashiersetting = false
            }
          }
        })
        .catch(function (error) {
          // console.log(error);
        });
    },
    synccasguergoods(hid) {
      var that = this;
      that.loading = true;
      that.$axios
        .post(
          that.apiuri,
          {
            action: "synccasguergoods",
            device: that.deviceid,
          },
          {
            headers: { Openid: that.userinfo.openid },
          }
        )
        .then(function (response) {
          that.loading = false;
          if (response.data.status == 200) {
            that.savelocal('stock', hid, response.data.data.quantity)
            that.savelocal('price', hid, response.data.data.price)
            that.savelocal('gid', hid, response.data.data.gid)
            that.$message({
              message: that.$t("global.syncsuccess"),
              type: "success",
            });
            that.gethdinfo()
          } else {
            that.$message.error(that.$t("global.failed"));
          }
        })
        .catch(function (error) {
          // console.log(error);
        });
    }
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body" v-loading="loading">
            <div v-if="Number(subid) === 7500" class="hd-shared-goods mb-3">
              <div class="d-flex align-items-center flex-wrap">
                <label class="mb-0 mr-2 font-weight-bold">{{ $t("device.hd.shared_goods") }}</label>
                <el-select
                  v-model="sharedGid"
                  filterable
                  :placeholder="$t('device.hd.select')"
                  style="min-width: 240px"
                  @change="saveSharedGid"
                >
                  <el-option v-for="(v, i) in goodslist" :key="i" :label="v.title" :value="v.id"></el-option>
                </el-select>
              </div>
              <div class="text-muted mt-2" style="font-size: 12px">{{ $t("device.hd.shared_goods_tip") }}</div>
            </div>
            <table class="table table-hover">
              <thead>
                <tr>
                  <th>{{ $t("device.hd.no") }}</th>
                  <th v-if="Number(subid) !== 7500">{{ $t("device.hd.name") }}</th>
                  <th v-if="subid != 7710">{{ $t("device.hd.stock") }}</th>
                  <th v-else>{{ $t("device.hd.singlestock") }}</th>
                  <th>{{ $t("device.hd.price") }}</th>
                  <th>{{ $t("device.hd.sale_price") }}</th>
                  <th>{{ $t("device.hd.diff") }}</th>
                  <th>{{ $t("device.hd.action") }}</th>
                </tr>
              </thead>
              <tbody v-if="hdinfo">
                <tr v-for="(val, idx) in hdinfo" :key="idx">
                  <td>{{ val.no }}</td>
                  <td v-if="subid != 7610 && Number(subid) !== 7500">
                    <el-select v-model="val.gid" filterable placeholder="请选择" @change="savev2('gid', val.id, idx)">
                      <!-- <el-option key="0" value="0" label="未选择"></el-option> -->
                      <el-option v-for="(v, i) in goodslist" :key="i" :label="v.title" :value="v.id"></el-option>
                    </el-select>
                    <!-- <select
                      name="goods"
                      class="form-control"
                      :id="'gid' + val.id"
                      @change="save('gid', val.id, $event)"
                    >
                      <option value="0" v-if="val.gid == 0">
                        {{ $t("device.hd.select") }}
                      </option>
                      <option
                        v-for="(v, i) in goodslist"
                        :value="v.id"
                        :key="i"
                        :selected="v.id == val.gid"
                      >
                        {{ v.title }}
                      </option>
                    </select> -->
                  </td>
                  <td v-if="subid != 7610">
                    <input type="number" class="form-control" :value="val.stock" :id="'stock' + val.id"
                      @change="save('stock', val.id, $event)" />
                  </td>
                  <td v-if="subid != 7610">
                    <input type="text" class="form-control" :value="val.price" :id="'price' + val.id"
                      @change="save('price', val.id, $event)" />
                  </td>
                  <td v-if="subid != 7610">
                    <input type="text" class="form-control" :value="val.sale_price" :id="'sale_price' + val.id"
                      @change="save('sale_price', val.id, $event)" />
                  </td>
                  <td v-if="subid != 7610">
                    <input type="number" class="form-control" :value="val.diff" :id="'diff' + val.id"
                      @change="save('diff', val.id, $event)" />
                  </td>
                  <td v-if="subid != 7610">

                    <select name="unity" class="form-control" :id="'unity' + val.id" v-model="val.unity"
                      @change="save('unity', val.id)">
                      <option value="0">{{ $t("device.orders.info.ml") }}</option>
                      <option value="1">CC</option>
                      <option value="3">{{ $t("device.orders.info.cup") }}</option>
                      <option value="4">{{ $t("device.orders.info.bottle") }}</option>
                    </select>

                  </td>
                  <td>
                    <button type="button" class="btn btn-primary btn-sm rounded-pill" @click="synccasguergoods(val.id)"
                      v-if="cashierconfig.type == 'yzg' && cashierconfig.status">
                      <span>{{ $t("device.hd.syncgoods") }}</span>
                    </button>
                    <button type="button" class="btn btn-primary btn-sm rounded-pill"
                      @click="changehdstatus(val.status, val.id)" v-if="subid == 7710">
                      <span v-if="val.status == 1">{{ $t("device.hd.stop") }}</span>
                      <span v-else>{{ $t("device.hd.start") }}</span>
                    </button>
                    <button type="button" class="btn btn-success btn-sm rounded-pill"
                      @click="openwithcommand('hd', val.id)" v-if="[7500, 7600, 2100, 7620].includes(Number(subid))">
                      {{ $t("device.hd.send") }}
                    </button>
                    <button type="button" class="btn btn-primary btn-sm rounded-pill"
                      @click="closewithcommand('hd', val.id)" v-if="subid == 7500">
                      {{ $t("device.hd.close") }}
                    </button>

                    <button type="button" class="btn btn-info btn-sm rounded-pill" @click="savecommand('goods', val.id)"
                      v-if="systemtype == 1 || Number(subid) === 7720">
                      {{ Number(subid) === 7720 ? $t("device.button.syncgoods") : $t("device.hd.save") }}
                    </button>
                    <button type="button" class="btn btn-info btn-sm rounded-pill" @click="savecommand('hd', val.id)"
                      v-if="subid == 7620">
                      {{ $t("device.hd.save") }}
                    </button>
                    <button type="button" class="btn btn-danger btn-sm rounded-pill" @click="deletes('hd', val.id)"
                      v-if="subid != 7610 && subid != 7620">
                      {{ $t("device.lists.delete") }}
                    </button>
                  </td>
                </tr>
                <tr v-if="subid == 7620">
                  <td>5</td>
                  <td colspan="6" style="text-align: center; cursor: pointer">
                    {{ $t("device.hd.bottleroute") }}
                  </td>
                  <td>
                    <button type="button" class="btn btn-success btn-sm rounded-pill" @click="openboolcommand('hd', id)"
                      v-if="subid == 7620">
                      {{ $t("device.hd.send") }}
                    </button>
                  </td>
                </tr>
                <tr v-if="subid == 7610">
                  <td colspan="6" style="text-align: center; cursor: pointer" @click="addhd(id)">
                    {{ $t("device.hd.add") }}
                  </td>
                </tr>
              </tbody>
              <tbody v-else>
                <tr>
                  <td colspan="6">
                    <el-result icon="info" :title="$t('global.waring')" :subTitle="$t('device.hd.nodata')">
                      <template slot="extra">
                        <el-button type="primary" size="medium" @click="initializehd">{{ $t("device.hd.initialize")
                          }}</el-button>
                      </template>
                    </el-result>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>